import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { motion } from 'framer-motion'
import { useCookies } from 'react-cookie'

import useStorage from 'containers/useStorage'
import { Redirect } from 'components/Redirect'
import Credential from '../../components/Credential'
import { selectToken } from '../../containers/authentication/authenticationSlice'
import useForgotPassword from 'containers/authentication/useForgotPassword'
import useQuery from 'containers/useQuery'

import ScreenLoading from 'components/ScreenLoading'

import mayaLogo from 'images/maya-logo.png'
import usePageTitle from 'containers/pageTitle/usePageTitle'

const ResetPassword = () => {
  const token = useSelector(selectToken)
  const [cookies] = useCookies(['user_id'])
  const [password, setPassword] = useState('')
  const [hasSubmitted, setHasSubmitted] = useState(false)
  const storage = useStorage()
  const query = useQuery()
  const id = query.get('id')
  const email = query.get('email')

  const {
    resetPasswordError,
    loadingResetPassword,
    removeResetPasswordError,
    resetPassword,
  } = useForgotPassword()

  //Page title
  usePageTitle('Reset Password - Maya')

  const handleSubmit = async (event) => {
    event.preventDefault()
    event.stopPropagation()
    setHasSubmitted(await resetPassword({ password, id, email }))
  }

  if (!id || !email) {
    return <>Wrong url</>
  }

  if (token && cookies.user_id && token.userId === parseInt(cookies.user_id)) {
    const url = storage.getUrlWhenLoggedIn()
    storage.removeUrlWhenLoggedIn()
    if (url) {
      return <Redirect to={url}></Redirect>
    }

    return <Redirect to={'/'}></Redirect>
  }

  return (
    <div className="page-column">
      <header>
        <div className="logo">
          <img src={mayaLogo} alt="Maya" />
        </div>
      </header>
      <div className="container-grow">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          className="container-column forgot-password-box"
        >
          <div>
            <h1 className="text-align-center">Reset Password</h1>
            <div className="secondary-text text-align-center">
              Choose your new password
            </div>
          </div>
          <form
            onSubmit={handleSubmit}
            className="container-grow container-column sign-in"
            noValidate
          >
            <div className="container-column width-100 credentials">
              <Credential
                value={password}
                setValue={setPassword}
                error={resetPasswordError.password}
                removeError={() => removeResetPasswordError('password')}
                label="New Password"
                type="password"
              />
            </div>
            {resetPasswordError.server && (
              <span className="server-error">{resetPasswordError.server}</span>
            )}
            <div className="submit-forgot-password">
              {hasSubmitted ? (
                <span className="material-icons-outlined green has-submitted">
                  check_circle
                </span>
              ) : (
                <>
                  {loadingResetPassword ? (
                    <ScreenLoading />
                  ) : (
                    <button type="submit" className="submit-button">
                      Reset Password
                    </button>
                  )}
                </>
              )}
            </div>
          </form>
          <div className="text-align-center secondary-text sign-up-footer">
            After resetting your password you can{' '}
            <NavLink className="link" to="/sign-in">
              sign in.
            </NavLink>
          </div>
        </motion.div>
      </div>
    </div>
  )
}

export default React.memo(ResetPassword)
